import React from 'react';
import DesignGenerator from '../components/DesignGenerator';
import AdBanner from '../components/AdBanner';
import AdNativeBanner from '../components/AdNativeBanner';
import { useLanguage } from '../contexts/LanguageContext';

const TattooDesignPage: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <div className="pt-24 pb-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto mb-12 text-center">
          <h1 className="text-4xl font-bold mb-4">
            {t('tattoo.title')}
          </h1>
          <p className="text-xl text-gray-400">
            {t('tattoo.subtitle')}
          </p>
        </div>
        
        {/* Native Banner Ad */}
        <div className="max-w-5xl mx-auto mb-8">
          <AdNativeBanner />
        </div>
        
        {/* Design Generator */}
        <div className="max-w-5xl mx-auto">
          <DesignGenerator type="tattoo" />
        </div>
        
        {/* Info Cards */}
        <div className="max-w-5xl mx-auto mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
            <h3 className="text-xl font-bold mb-4">{t('tattoo.styles.title')}</h3>
            <ul className="space-y-3 text-gray-300">
              <li>{t('tattoo.styles.traditional')}</li>
              <li>{t('tattoo.styles.minimalist')}</li>
              <li>{t('tattoo.styles.geometric')}</li>
              <li>{t('tattoo.styles.watercolor')}</li>
              <li>{t('tattoo.styles.blackwork')}</li>
              <li>{t('tattoo.styles.tribal')}</li>
            </ul>
          </div>
          
          <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
            <h3 className="text-xl font-bold mb-4">{t('tattoo.tips.title')}</h3>
            <ol className="space-y-4 text-gray-300 list-decimal ml-5">
              <li>
                <span className="font-medium text-white">{t('tattoo.tips.specific.title')}</span>
                <p className="mt-1 text-gray-400">{t('tattoo.tips.specific.description')}</p>
              </li>
              <li>
                <span className="font-medium text-white">{t('tattoo.tips.references.title')}</span>
                <p className="mt-1 text-gray-400">{t('tattoo.tips.references.description')}</p>
              </li>
              <li>
                <span className="font-medium text-white">{t('tattoo.tips.variations.title')}</span>
                <p className="mt-1 text-gray-400">{t('tattoo.tips.variations.description')}</p>
              </li>
              <li>
                <span className="font-medium text-white">{t('tattoo.tips.consult.title')}</span>
                <p className="mt-1 text-gray-400">{t('tattoo.tips.consult.description')}</p>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TattooDesignPage;